module.exports = __webpack_public_path__ + "static/img/Intelligent-monitoring-system1.f997fc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Intelligent-monitoring-system1.jpg
// module id = wDYD
// module chunks = 0